import { Container } from '@eliadmin/core/src/components/ui/container';
import { useEliProductDetails } from '@eliadmin/core/src/hooks/proform-eli-product-detail';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { useVariantsStore } from '@eliadmin/core/src/stores/variant-store';
import { getProformImageUrl, parseProformNumber } from '@eliadmin/core/src/utils/proform-utils';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import Image from '@eliadmin/core/src/components/image/image-wrapped';

export function ProductTabTechnical() {
  const product = useVariantsStore(s => s.product);

  const detail = useEliProductDetails(product.code);

  const { t } = useTranslations();

  const techInfoByCleneni = detail.data?.root?.smako_tech_info?.smako_tech_info?.reduce?.(
    (acc, curr) => {
      if (!acc[curr.cleneni]) {
        acc[curr.cleneni] = [];
      }

      acc[curr.cleneni].push(curr);

      return acc;
    },
    {} as Record<
      string,
      NonNullable<typeof detail.data>['root']['smako_tech_info']['smako_tech_info']
    >,
  );

  const cleneniKeys = Object.keys(techInfoByCleneni ? techInfoByCleneni : {}).sort((a, b) =>
    a.localeCompare(b),
  );

  return (
    <Container className={cn('flex flex-col px-2', 'ea-product-detail-tab-technical')}>
      {/* <h2 className="mb-4 text-2xl font-bold">{t('text1035')}</h2> */}
      {/* <div className="grid grid-cols-12 gap-4">
        <div className="col-span-12 sm:col-span-6 lg:col-span-4">
          <h3 className="text-[16px] font-semibold">Minimálni výška</h3>
          <p>50mm</p>
        </div>
        <div className="col-span-12 sm:col-span-6 lg:col-span-4">
          <h3 className="text-[16px] font-semibold">Minimálni výška</h3>
          <p>50mm</p>
        </div>
        <div className="col-span-12 sm:col-span-6 lg:col-span-4">
          <h3 className="text-[16px] font-semibold">Minimálni výška</h3>
          <p>50mm</p>
        </div>
        <div className="col-span-12 sm:col-span-6 lg:col-span-4">
          <h3 className="text-[16px] font-semibold">Minimálni výška</h3>
          <p>50mm</p>
        </div>
      </div> */}
      {!!cleneniKeys.length && (
        <>
          <h2 className="mb-4 mt-4 text-2xl font-bold">{t('text1034')}</h2>
          <div className="grid w-full grid-cols-12 gap-x-4 gap-y-6">
            {cleneniKeys.map(cleneni => {
              const techInfo = [...techInfoByCleneni[cleneni]].sort(
                (a, b) =>
                  // a.poradi_zobrazeni.localeCompare(b.poradi_zobrazeni),
                  parseProformNumber(a.poradi_zobrazeni) - parseProformNumber(b.poradi_zobrazeni),
              );

              if (!techInfo.length) {
                return null;
              }

              return (
                <div className="col-span-12 flex flex-col gap-4 md:col-span-6" key={cleneni}>
                  {techInfo.map(item => (
                    <div
                      key={item.kod}
                      className="flex items-center justify-start gap-4 overflow-hidden md:col-span-6"
                    >
                      {item.pic && (
                        <div className="h-20 min-h-20 w-20 min-w-20 overflow-hidden">
                          <Image
                            src={getProformImageUrl(item.pic)}
                            alt={item.kod}
                            height={80}
                            width={80}
                            className="min-h-[80px] min-w-[80px] object-fill"
                          />
                        </div>
                      )}
                      <div className="flex flex-col">
                        <h3 className="text-[16px] font-semibold">{item.popis}</h3>
                        {/* <p>
                          High strength, stability, scratch resistance and splash resistance. Black
                          color but covered with multi-layer melamine coating in rich color range
                        </p> */}
                      </div>
                    </div>
                  ))}
                </div>
              );
            })}
          </div>
        </>
      )}
    </Container>
  );
}
